export class ItemContextModel {

    constructor(public item: any, 
                public nextId: string, 
                public previousId: string, 
                public topic,
                public isSource: boolean = false,
                public isCuration: boolean = false){};
}
